import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { NavigateProps } from 'react-router/dist/lib/components';

const NavigateWithSearch = React.memo((props: NavigateProps) => {
    const location = useLocation();
    return <Navigate {...props} to={`${props.to}${location.search}`} replace />;
});

export default NavigateWithSearch;
